var map = {
	"./24001_SIERRA/24001_SIERRA_01.mp4": 7741,
	"./24001_SIERRA/24001_SIERRA_02.mp4": 8426,
	"./24002_ATELIER-PM151/24002_ATELIER-PM151_01.mp4": 6799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4950;